<div class="flex items-center">
  <!-- Decrement Button -->
  <button
    (click)="updateNumberOfTickets(-1)"
    type="button"
    id="decrement-button"
    [disabled]="disabled"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100 disabled:hover:bg-gray-100"
  >
    <svg
      class="h-2.5 w-2.5 text-gray-900"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 2"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M1 1h16"
      />
    </svg>
  </button>

  <!-- Display Input -->
  <input
    [(ngModel)]="numberOfTickets"
    (ngModelChange)="onInputChange($event)"
    type="text"
    id="counter-input"
    [disabled]="disabled"
    class="w-10 shrink-0 border-0 bg-transparent text-center text-sm font-medium text-gray-900 focus:outline-none focus:ring-0 disabled:cursor-not-allowed"
    required
  />

  <!-- Increment Button -->
  <button
    (click)="updateNumberOfTickets(1)"
    type="button"
    id="increment-button"
    [disabled]="disabled"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100 disabled:hover:bg-gray-100"
  >
    <svg
      class="h-2.5 w-2.5 text-gray-900"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 1v16M1 9h16"
      />
    </svg>
  </button>
</div>
